import React, {PureComponent, Component} from 'react';
import styled from "styled-components";
import {switchProp} from 'styled-tools';
import ReactSlider from 'react-slider'

const sidebarWidth = 100;

const StyledSlider = styled(ReactSlider)`
    width: 500px;
    height: 25px;
    display: inline-block
`;

const StyledThumb = styled.div`
    height: 25px;
    line-height: 25px;
    text-align: center;
    background-color: #000;
    color: #fff;
    cursor: grab;
    padding: 0px 5px;
`;

const StyledTrack = styled.div`
    top: 0;
    bottom: 0;
    background-color: ${props => props.index === 2 ? '#f00' : props.index === 1 ? '#ddd' : '#0f0'};
`;

const SliderLabel = styled.div`
    display:inline-block;
    font-weight: bold;
    vertical-align: top;
    padding: 3px 10px;    
    width: 5rem;
    text-align: right;
    margin-right: 0.5rem;
`;

const ControlsFormat = styled.div`
    display:inline-block;
    vertical-align: top;
    margin: 20px;
`;

const ImageFormat = styled.img`
    display:inline-block;
    box-shadow: 0.5rem 0.5rem 0.5rem rgba(0,0,0,0.2);
`;

const ImagePreview = styled.img`
    display:inline-block;
    border: 1px solid grey;
    width: 100px;
`;

const RefreshButton = styled.button`
    width: 150px;
    height: 30px;
    background-color: ${switchProp('enabled', {true: "#aaaaaa", false: "#eeeeee"})};
    border: 0;
    border-radius: 10px;
    color: white;
    font-size: 1rem;
    font-weight: bold;
    margin-left: 120px;
    margin-right: 20px;
    vertical-align: top;
    cursor: ${switchProp('enabled', {true: "pointer", false: "auto"})}; 
    &:focus {
        outline: none;
        border: none;
    }
`;


const SliderWrapper = styled.div`
    margin: 10px;
`;

const ModeWrapper = styled.div`
    margin: 10px;
`;
const ModeSelect = styled.select`
    display:inline-block;
`;

const MIN_ITERATION=1000;
const MAX_ITERATION=500000;

const MIN_PRECISION=15;
const MAX_PRECISION=30;

export class PositionDisplay extends PureComponent {
    render() {
        const half_frame = this.props.frame_size / 2;
        const half_span = this.props.max_span / (2 * this.props.depth);
        return <div>
            <div>
                cursor x: {this.props.cursor_x}
            </div>
            <div>
                cursor y: {this.props.cursor_y}
            </div>
            <div>
                center x: {this.props.center_x + half_span * (this.props.cursor_x - half_frame) / half_frame}
            </div>
            <div>
                center y: {this.props.center_y + half_span * (this.props.cursor_y - half_frame) / half_frame}
            </div>
        </div>
    }
}

const ChaosSlider = props => {
    const Thumb = (props, state) => <StyledThumb {...props}>{state.valueNow}</StyledThumb>;
    const Track = (props, state) => <StyledTrack {...props} index={state.index}/>;
    return <SliderWrapper>
        <SliderLabel>chaos:</SliderLabel>
        <StyledSlider
            max={50}
            min={1}
            defaultValue={5}
            renderTrack={Track}
            renderThumb={Thumb}
            onChange={props.onChange}
        />
    </SliderWrapper>
}

const DepthSlider = props => {
    const Thumb = (props, state) => <StyledThumb {...props}>{state.valueNow}</StyledThumb>;
    const Track = (props, state) => <StyledTrack {...props} index={state.index}/>;
    return <SliderWrapper>
        <SliderLabel>depth:</SliderLabel>
        <StyledSlider
            max={100}
            min={1}
            defaultValue={2}
            renderTrack={Track}
            renderThumb={Thumb}
            onChange={props.onChange}
        />
    </SliderWrapper>
}

const SizeSlider = props => {
    const Thumb = (props, state) => <StyledThumb {...props}>{state.valueNow}</StyledThumb>;
    const Track = (props, state) => <StyledTrack {...props} index={state.index}/>;
    return <SliderWrapper>
        <SliderLabel>size:</SliderLabel>
        <StyledSlider
            max={5000}
            min={250}
            step={250}
            defaultValue={250}
            renderTrack={Track}
            renderThumb={Thumb}
            onChange={props.onChange}
        />
    </SliderWrapper>
}

const LimitSlider = props => {
    const Thumb = (props, state) => <StyledThumb {...props}>{state.valueNow}</StyledThumb>;
    const Track = (props, state) => <StyledTrack {...props} index={state.index}/>;
    return <SliderWrapper>
        <SliderLabel>limit (k):</SliderLabel>
        <StyledSlider
            max={MAX_ITERATION / 1000}
            min={MIN_ITERATION / 1000}
            step={1}
            defaultValue={1}
            renderTrack={Track}
            renderThumb={Thumb}
            onChange={props.onChange}
        />
    </SliderWrapper>
}

const PrecisionSlider = props => {
    const Thumb = (props, state) => <StyledThumb {...props}>{state.valueNow}</StyledThumb>;
    const Track = (props, state) => <StyledTrack {...props} index={state.index}/>;
    return <SliderWrapper>
        <SliderLabel>precision:</SliderLabel>
        <StyledSlider
            max={MAX_PRECISION}
            min={MIN_PRECISION}
            defaultValue={MIN_PRECISION}
            renderTrack={Track}
            renderThumb={Thumb}
            onChange={props.onChange}
        />
    </SliderWrapper>
}

const ModeSelector = props => {
    return <ModeWrapper>
        <SliderLabel>mode:</SliderLabel>
        <ModeSelect onChange={props.onChange}>
            <option selected>inner</option>
            <option>outer</option>
            <option>both</option>
        </ModeSelect>
    </ModeWrapper>
}

const base_url = process.env.REACT_APP_BASE_URL + "/react-apps/src/fracto/fracto.php";
const max_span = 5.0;
const $ON_CLICK_VALUE = "-1234567";

export class Image extends Component {

    state = {
        center_x: -0.75,
        center_y: 0.0,
        max_span: max_span,
        chaos: 5,
        depth: 2,
        level: 1,
        limit: 1,
        precision: 0,
        refresh_enabled: true,
        refresh_token: "Fracto Image",
        frame_size: 250,
        mode: 'inner',
        timer: null,
        preview: null,
        show_preview: false
    }

    componentDidMount() {
        document.title = 'fracto';
        document.body.style.margin = 0;
        document.body.style.fontFamily = "Arial";
        this.handle_refresh(this.state.center_x, this.state.center_y);
    }

    handle_click = (e) => {
        const half_frame = this.state.frame_size / 2;
        const half_span = this.state.max_span / (2 * this.state.depth);
        const center_x = this.state.center_x + half_span * (this.state.cursor_x - half_frame) / half_frame;
        const center_y = this.state.center_y - half_span * (this.state.cursor_y - half_frame) / half_frame;

        this.handle_refresh(center_x, center_y);
        this.setState({
            center_x: center_x,
            center_y: center_y
        });
    };

    handle_refresh = (center_x, center_y = $ON_CLICK_VALUE) => {
        if (!this.state.refresh_enabled) {
            return;
        }
        if (center_y === $ON_CLICK_VALUE) {
            center_x = this.state.center_x;
            center_y = this.state.center_y;
        }

        const refresh_token = Math.random() * 10000;
        const src_url = base_url
            + "?chaos=" + this.state.chaos
            + "&r=" + refresh_token
            + "&depth=" + this.state.depth
            + "&level=" + this.state.level
            + "&center_x=" + center_x
            + "&center_y=" + center_y
            + "&frame_size=" + this.state.frame_size
            + "&max_span=" + this.state.max_span
            + "&limit=" + this.state.limit * 1000
            + "&precision=" + this.state.precision
            + "&mode=" + this.state.mode
        ;
        console.log(src_url);
        const self = this;
        const timer = setInterval(function () {
            self.setState({
                show_preview: true,
                preview: process.env.REACT_APP_BASE_URL + "/react-apps/src/fracto/img/in_progress.jpg?r=" + Math.random()
            })
        }, 1000)
        this.setState({
            refresh_enabled: false,
            src_url: src_url,
            timer: timer
        });
    };

    handle_mousemove = (e) => {
        this.setState({
            cursor_x: e.clientX,
            cursor_y: this.state.frame_size - e.clientY,
        });
    };

    chaos_change = (new_value) => {
        this.setState({chaos: new_value});
    };
    depth_change = (new_value) => {
        this.setState({
            depth: Math.pow(2, new_value),
            level: new_value
        });
    };
    size_change = (new_value) => {
        this.setState({frame_size: new_value});
    };
    limit_change = (new_value) => {
        this.setState({limit: new_value});
    };
    precision_change = (new_value) => {
        this.setState({precision: new_value});
    };
    mode_change = (event) => {
        this.setState({mode: event.target.value});
    };

    handle_loaded = (e) => {
        clearInterval(this.state.timer);
        this.setState({
            refresh_enabled: true,
            show_preview: false
        });
    }

    render() {
        const chaosSlider = this.state.mode === 'outer' ? <ChaosSlider onChange={this.chaos_change}/> : '';
        const precisionSlider = this.state.mode === 'outer' ? <PrecisionSlider onChange={this.precision_change}/> : '';
        const imagePreview = this.state.show_preview ? <ImagePreview src={this.state.preview}/> : '';
        return <div>
            <ImageFormat
                style={{width: this.state.frame_size + sidebarWidth}}
                src={this.state.src_url}
                onClick={this.handle_click}
                onMouseMove={this.handle_mousemove}
                onLoad={this.handle_loaded}
            />
            <ControlsFormat>
                <ModeSelector onChange={this.mode_change}/>
                <SizeSlider onChange={this.size_change}/>
                <DepthSlider onChange={this.depth_change}/>
                <LimitSlider onChange={this.limit_change}/>
                {chaosSlider}
                {precisionSlider}
                <RefreshButton
                    onClick={this.handle_refresh}
                    enabled={this.state.refresh_enabled}>
                    refresh now
                </RefreshButton>
                {imagePreview}
            </ControlsFormat>
            <PositionDisplay {...this.state} />
        </div>;

    }
}

export default Image;
